import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@/components/ui/Icon';
import styles from '../../Navigator.module.scss';
import { UnstyledButton } from '../../../../../../ui/Buttons';
import useFlags from '../../../../../../../hooks/useFlags';
import cn from '../../../../../../../utils/cn';

const FullScreen = ({ fullScreenRef }) => {
  const [inFullScreen, setIsFullScreen] = useState(false);
  const { teacherPacedMode } = useFlags();

  const checkFullScreen = () => {
    if (document.fullscreenElement === null) {
      setIsFullScreen(false);
    }
  };

  useEffect(() => {
    $('body').on('fullscreenchange', checkFullScreen);
    return () => $('body').off('fullscreenchange', checkFullScreen);
  }, [inFullScreen]);

  const requestFullScreen = (node) => {
    if (node.requestFullscreen) node.requestFullscreen();
    else if (node.webkitRequestFullscreen) node.webkitRequestFullscreen();

    setIsFullScreen(true);
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();

    setIsFullScreen(false);
  };

  const onClick = () => {
    if (!(fullScreenRef && fullScreenRef.current)) return;

    const { current } = fullScreenRef;

    if (inFullScreen) exitFullScreen();
    else requestFullScreen(current);
  };

  if (!(fullScreenRef && fullScreenRef.current)) return null;

  const fullScreenText = () => (inFullScreen ? 'Exit Full Screen' : 'Enter Full Screen');

  return (
    <UnstyledButton
      className={cn(styles.settingsMenuRow, teacherPacedMode ? styles.teacherPacedUpdates : styles.legacy)}
      onClick={onClick}
    >
      <span aria-label={fullScreenText()} className={styles.menuIconButton}>
        <Icon icon={inFullScreen ? 'Collapse' : 'Expand'} size={16} />
      </span>
      <div>{fullScreenText()}</div>
    </UnstyledButton>
  );
};

FullScreen.defaultProps = {
  fullScreenRef: null,
};

export const FullScreenPropTypes = PropTypes.shape({
  fullScreenRef: PropTypes.oneOfType([
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ])
});

FullScreen.propTypes = FullScreenPropTypes.isRequired;

export default FullScreen;
